import { bimAxios } from "@/config/axios";
import { AxiosResponse } from "axios";

export function exportDxf(projectUuid: string, modelUuid: string, properties: any[], params?: {}): Promise<AxiosResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/models/${modelUuid}/export-dxf`, properties, {
        params: {
            ...params,
        },
        responseType: 'blob',
        timeout: 240000,
    })
}